import { useEffect } from "react";

const AnimatedCircles = () => {
  const generateCircle = (className) => {
    let sizeW = Math.random() * 12;
    let duration = Math.random() * 3;
    let e = document.createElement("div");
    e.setAttribute("class", className);
    document.body.appendChild(e);
    e.style.width = 2 + sizeW + "px";
    e.style.left = Math.random() * window.innerWidth + "px";
    e.style.animationDuration = 2 + duration + "s";
    setTimeout(() => {
      document.body.removeChild(e);
    }, 5000);
  };

  const lines = () => generateCircle("circle");
  const lines2 = () => generateCircle("circle2");

  useEffect(() => {
    const interval1 = setInterval(lines, 200);
    const interval2 = setInterval(lines2, 200);

    return () => {
      clearInterval(interval1);
      clearInterval(interval2);
    };
  }, []);

  return null;
};

export default AnimatedCircles;
